import React, { useEffect, useState } from "react";
import { AntdButton, Container, Inner, Section } from "./styles.js";
import { Typo } from "../../../../../../components/layout/theme/index.js";
import { Form, Input, Select, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useReport } from "../../../../../../contexts/ReportContext.js";
import { useMatomo } from "@datapunt/matomo-tracker-react";

import { get_genders, get_identification_types, get_marital_statuses } from "../../../../../../api/endpoints/sysone-endpoints/sysoneEndpoints.js";

const EmissionPersonalData = ({ nextMainStep, nextSubStep, isMobile }) => {
	const [form] = Form.useForm();
	const { trackEvent } = useMatomo();
	const { reportForm, updateReportForm } = useReport();
	const [initialValues, setInitialValues] = useState(null);
	const [typeOfDocuments, setTypeOfDocuments] = useState(null);
	const [selectedTypeOfDocument, setSelectedTypeOfDocument] = useState(null);
	const [genres, setGenres] = useState(null);
	const [selectedGenre, setSelectedGenre] = useState(null);
	const [civilStates, setCivilStates] = useState(null);
	const [selectedCivilState, setSelectedCivilState] = useState(null);

	useEffect(() => {
		const fetch_initial_values = () => {
			const values = {
				documentNumber: reportForm?.emissionPersonalData?.documentNumber,
				address: reportForm?.emissionPersonalData?.address,
				patent:
					reportForm?.carData?.patent ??
					reportForm?.emissionPersonalData?.carPatent,
				carMotor: reportForm?.emissionPersonalData?.carMotor,
				carChasis: reportForm?.emissionPersonalData?.carChasis,
			};

			setSelectedTypeOfDocument(
				reportForm?.emissionPersonalData?.typeOfDocumentId
			);

			setSelectedCivilState(reportForm?.emissionPersonalData?.civilStateId);

			setSelectedGenre(reportForm?.emissionPersonalData?.genreId);

			setInitialValues(values);
		};
		fetch_initial_values();
	}, [reportForm]);

	useEffect(() => {
		fetch_types_of_document();
		fetch_genres();
		fetch_civil_states();
	}, []);

	const fetch_types_of_document = async () => {
		const res = await get_identification_types();
		setTypeOfDocuments(
			res?.values.map((b) => ({
				value: b.code,
				label: b.name,
			}))
		);
	};

	const fetch_genres = async () => {
		const res = await get_genders();
		setGenres(
			res?.values?.map((b) => ({
				value: b.code,
				label: b.name,
			}))
		);
	};

	const fetch_civil_states = async () => {
		const res = await get_marital_statuses();
		setCivilStates(
			res?.values.map((b) => ({
				value: b.code,
				label: b.name,
			}))
		);
	};

	useEffect(() => {
		if (initialValues) {
			form.setFieldsValue(initialValues);
		}
	}, [initialValues, form]);

	const handleNextStep = (values) => {
		const updatedValues = {
			typeOfDocumentId: selectedTypeOfDocument,
			documentNumber: values?.documentNumber,
			civilStateId: selectedCivilState,
			genreId: selectedGenre,
			address: values?.address,
			patent: values?.patent,
			carMotor: values?.carMotor,
			carChasis: values?.carChasis,
		};
		trackEvent({
			category: "button-click",
			action: "next-button",
			name: `step3.issue&Payment-(1)detailedPersonalData::${JSON.stringify(
				updatedValues
			)}`,
		});
		updateReportForm(updatedValues);

		nextSubStep(1);
	};

	return (
		<Form
			form={form}
			name="emission-personal-data-form"
			initialValues={initialValues}
			onFinish={handleNextStep}
		>
			<Inner>
				<Typo level={isMobile ? 3 : 2} style={{ textAlign: "center" }}>
					Perfecto, ahora necesitamos unos datos más para emitir tu póliza
				</Typo>
				<Container isMobile={isMobile}>
					<Section>
						<Form.Item
							name="identificationType"
							style={{ marginBottom: 0, width: "30%" }}
							rules={[
								{ required: true, message: "Tipo de documento requerido" },
							]}
						>
							<Select
								showSearch
								placeholder="Tipo"
								optionFilterProp="children"
								value={selectedTypeOfDocument}
								onChange={(e) => setSelectedTypeOfDocument(e)}
								filterOption={(input, option) =>
									(option?.label ?? "")
										.toLowerCase()
										.includes(input.toLowerCase())
								}
								options={typeOfDocuments}
								style={{ width: "100%" }}
							/>
						</Form.Item>
						<Form.Item
							name="documentNumber"
							style={{ marginBottom: 0, width: "70%" }}
							rules={[
								{ required: true, message: "Nro de documento requerido" },
								{
									pattern: /^[A-Z0-9]+$/i,
									message: "Solo caracteres alfanuméricos",
								},
							]}
						>
							<Input
								placeholder="Numero de Documento"
								style={{ minWidth: "250px" }}
							/>
						</Form.Item>
					</Section>
					<Section>
						<Form.Item name="marital-status"
							style={isMobile ? { minWidth: "48%" } : { flex: "1 1" }}
							rules={[
								{ required: true, message: "Ingrese el estado civil" },
							]}>
							<Select
								showSearch
								placeholder="Estado civil"
								optionFilterProp="children"
								value={selectedCivilState}
								onChange={(e) => setSelectedCivilState(e)}
								filterOption={(input, option) =>
									(option?.label ?? "")
										.toLowerCase()
										.includes(input.toLowerCase())
								}
								options={civilStates}

							/>
						</Form.Item>

						<Form.Item name="gender"
							style={isMobile ? { minWidth: "48%" } : { flex: "1 1" }}
							rules={[
								{ required: true, message: "Ingrese el genero" },
							]}>
							<Select
								showSearch
								placeholder="Género"
								optionFilterProp="children"
								value={selectedGenre}
								onChange={(e) => setSelectedGenre(e)}
								filterOption={(input, option) =>
									(option?.label ?? "")
										.toLowerCase()
										.includes(input.toLowerCase())
								}
								options={genres}

							/>
						</Form.Item>

					</Section>
				</Container>
				<Container isMobile={isMobile}>
					<Section>
						<Form.Item
							name="address"
							style={{ marginBottom: 0, width: "100%" }}
							rules={[
								{ required: true, message: "Ingrese el domicilio" },
							]}
						>
							<Input placeholder="Domicilio" style={{ minWidth: "250px" }} />
						</Form.Item>
					</Section>
				</Container>
				<Container isMobile={isMobile}>
					<Section>
						<Form.Item
							name="patent"
							style={{ marginBottom: 0, width: "100%" }}
							rules={[
								{ required: true, message: "Ingrese la patente" },
								{
									pattern: /^[A-Z0-9]+$/i,
									message: "Solo caracteres alfanuméricos",
								},
							]}
						>
							<Input placeholder="Patente" style={{ minWidth: "80px" }} />
						</Form.Item>

						<Form.Item
							name="carMotor"
							style={{ marginBottom: 0, width: "100%" }}
							rules={[
								{ required: true, message: "Ingrese número de motor" },
								{
									pattern: /^[A-Z0-9]{6,17}$/i,
									message: "Debe tener entre 6 y 17 caracteres alfanuméricos",
								},
							]}
						>
							<Input
								placeholder="Motor"
								style={{ minWidth: "80px" }}
								suffix={
									<Tooltip title="El número de motor se encuentra en la cédula verde del vehículo">
										<InfoCircleOutlined style={{ color: "#1677ff", cursor: "help" }} />
									</Tooltip>
								}
							/>
						</Form.Item>

						<Form.Item
							name="carChasis"
							style={{ marginBottom: 0, width: "100%" }}
							rules={[
								{ required: true, message: "Ingrese número de chasis" },
								{
									pattern: /^[A-HJ-NPR-Z0-9]{17}$/i,
									message: "Debe tener exactamente 17 caracteres alfanuméricos válidos",
								},
							]}
						>
							<Input placeholder="Chasis" style={{ minWidth: "80px" }} />
						</Form.Item>

					</Section>
				</Container>
				<Section style={{ maxWidth: "250px", maxHeight: "100px", marginTop: "20px" }}>
					<AntdButton
						key="PrevStep2CarParsonalData"
						onClick={() => nextMainStep(1)}
						style={{ padding: "20px 20px" }}
					>
						<Typo level={5}>Anterior</Typo>
					</AntdButton>
					<AntdButton
						key="NextStep2CarPersonalData"
						type="primary"
						htmlType="submit"
						style={{ padding: "20px 20px" }}
					>
						<Typo level={5} type="white">
							Siguiente
						</Typo>
					</AntdButton>
				</Section>
			</Inner>
		</Form>
	);
};

export default EmissionPersonalData;
